/**
 * Vite dev-proxy host detection — housekeeping C7 (2026-08-16).
 *
 * getApiUrl (apiClient.ts) and resolveApiBase (streamingContentService.ts)
 * used to special-case ONLY `localhost:5173`, so serving the dashboard on
 * `http://app.rnkrocket.localhost:5173` (mandated for RnkCookie CMP QA —
 * plain localhost is a different tenant's config) or `127.0.0.1:5173`
 * THREW "API URL not configured" unless VITE_API_URL was set in .env.
 *
 * This predicate widens the dev special-case to the whole loopback class
 * on the fixed dev port 5173 (CLAUDE.md hard gate: UD port is 5173):
 *   localhost / 127.0.0.1 / *.localhost  — port 5173 only.
 * Dot-boundary safe: `localhost.evil.com` does not match. Any other
 * host/port combination still fails closed (the production throw for
 * genuinely unconfigured builds is unchanged).
 *
 * Zero dependencies and no module side effects by design —
 * streamingContentService deliberately does NOT import apiClient (which
 * instantiates a client at module load), so the shared logic lives here.
 */
export const isViteDevProxyHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const { hostname, port } = window.location;
  if (port !== '5173') return false;
  const host = hostname.toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost');
};
